<template>
  <div>
    <div class="table-responsive mb-0">
      <b-table
        class="datatables"
        :items="sectionSpeed"
        :fields="fields"
        responsive="sm"
      >
        <template #cell(actions)="row">
          <b-button
            variant="primary"
            size="sm"
            :id="`${row.item.id}-raise-challan-btn`"
            @click="generateChallan"
          >
            Generate Challan
          </b-button>
        </template>
      </b-table>
    </div>
  </div>
</template>
<script>
import Swal from "sweetalert2";
export default {
  data() {
    return {
      sectionSpeed: [
        {
          section: "17 LHS to 25 LHS",
          speed: this.randomNumber(80, 140) + ' km/h',
        },
      ],
      fields: [
        {
          key: "section",
          label: "Sections",
          sortable: true,
        },
        {
          key: "speed",
          label: "Speed",
          sortable: false,
        },
        {
          key: "actions",
          label: "Action",
          sortable: false,
        },
      ],
    };
  },
  methods: {
    generateChallan() {
      Swal.fire("Challan Generated", "", "success");
    },
    randomNumber(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
  },
};
</script>